import React from "react";
import { useSelector } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";
import loadable from "@react-loadable/revised";
import withFieldsCheck from "@clarion/foundation/dist/Helpers/containers/WithFieldsCheck";
import "@clarion/foundation/dist/Theming/styles/forms.css";
import "@clarion/foundation/dist/Theming/styles/account.css";
const LoadableForgottenPasswordPanel = loadable({
  loader: () => import("./ForgottenPasswordPanel/index"),
  loading() {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
});
const ForgottenPassword = ({
  fields,
  sitecoreContext,
  t,
  rendering
}) => {
  const loader = useSelector(state => state.loader);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loader.loadForgottenPasswordModals && /*#__PURE__*/React.createElement(LoadableForgottenPasswordPanel, {
    fields: fields,
    sitecoreContext: sitecoreContext,
    t: t,
    rendering: rendering
  }));
};
const ForgottenPasswordWithFieldsCheck = withFieldsCheck(ForgottenPassword);
const ForgottenPasswordWithFieldsCheckAndTranslation = withTranslation()(ForgottenPasswordWithFieldsCheck);
export default withSitecoreContext()(ForgottenPasswordWithFieldsCheckAndTranslation);